import React from "react";

const sizes = {
  textxs: "text-[24px] font-normal not-italic md:text-[22px]",
  texts: "text-[31px] font-normal not-italic md:text-[29px] sm:text-[27px]",
  textmd: "text-[36px] font-normal not-italic md:text-[34px] sm:text-[32px]",
  textlg: "text-[60px] font-normal italic md:text-[52px] sm:text-[46px]",
};

const Text = ({ children, className = "", as, size = "texts", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component className={`font-ibmplexmono ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
